import { Stack, useTheme } from '@chakra-ui/react';

import {
  AppointmentCheckoutData,
  AppointmentInterface,
  DiscountCode
} from 'types';

import { DiscountItem } from 'components';
import { ReviewItem } from './components';

interface ReviewListProps {
  data: AppointmentCheckoutData;
  promoData: DiscountCode | null;
  promoCode: string;
  selectedAppointment: AppointmentInterface;
}

const ReviewList = ({
  data,
  selectedAppointment,
  promoData,
  promoCode
}: ReviewListProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepSuccess: { reviewList }
        }
      }
    }
  } = useTheme();
  const isDiscountApplied = promoData?.is_valid;

  /*
   * No more support for percentage discount
  const totalPrice = data?.amount;
  const discountPercentValue = promoData?.discount_prc || 0;
  const absoluteDiscountValue = totalPrice
    ? (totalPrice / 100) * discountPercentValue
    : 0;
  */

  return (
    <Stack bg={reviewList.background} overflow='hidden' gap={0}>
      {data?.appt_sv.map((service) => {
        const initialServiceData = selectedAppointment?.services.find(
          (item) => item?.svc_num === service?.sv_id
        );

        return (
          <Stack gap='5px' w='100%' key={service?.sv_id}>
            <ReviewItem
              item={service}
              initialServiceData={initialServiceData}
            />
          </Stack>
        );
      })}

      {isDiscountApplied && (
        <DiscountItem
          onRemoveDiscount={null}
          promoData={promoData}
          promoCode={promoCode}
        />
      )}
    </Stack>
  );
};

export default ReviewList;
